import { render, staticRenderFns } from "./ThirdPartyInsuranceCreate.vue?vue&type=template&id=0ca4d760"
import script from "./ThirdPartyInsuranceCreate.vue?vue&type=script&lang=js"
export * from "./ThirdPartyInsuranceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports